/* In-house Order Tracking (Module 2). Calls the App Proxy /apps/ai/order-status.
   - Logged-in customers: Shopify injects logged_in_customer_id at the proxy, so a
     bare fetch returns that customer's recent orders.
   - Guests: a `token` (from their order magic-link) in the page URL is forwarded;
     the backend returns only the one order that token resolves to.
   No free-text email lookup — that path does not exist by design. */
(function () {
  var root = document.querySelector("[data-ostk]");
  if (!root) return;

  var path = root.getAttribute("data-order-status-path") || "/apps/ai/order-status";
  var loggedIn = root.getAttribute("data-logged-in") === "1";
  var listEl = root.querySelector(".ostk-list");
  var msgEl = root.querySelector(".ostk-msg");

  function tokenFromUrl() {
    try {
      return new URLSearchParams(window.location.search).get("token");
    } catch (e) {
      return null;
    }
  }

  function esc(s) {
    var d = document.createElement("div");
    d.textContent = s == null ? "" : String(s);
    return d.innerHTML;
  }

  function showMsg(text, kind) {
    if (!msgEl) return;
    msgEl.textContent = text;
    msgEl.className = "ostk-msg is-" + (kind || "info");
    msgEl.hidden = false;
  }

  function badgeClass(status) {
    var s = (status || "").toUpperCase();
    if (s.indexOf("FULFILLED") > -1 || s === "PAID") return "is-fulfilled";
    if (s.indexOf("UNFULFILLED") > -1 || s.indexOf("PENDING") > -1) return "is-pending";
    return "";
  }

  function renderOrder(o) {
    var items = (o.lineItems || [])
      .map(function (li) { return "<li>" + esc(li.quantity) + " × " + esc(li.title) + "</li>"; })
      .join("");

    var tracking = "";
    (o.fulfillments || []).forEach(function (f) {
      (f.tracking || []).forEach(function (t) {
        var label = (t.company ? esc(t.company) + " — " : "") + esc(t.number || "Tracking");
        var eta = f.estimatedDeliveryAt
          ? '<span class="ostk-eta">Est. ' + esc(new Date(f.estimatedDeliveryAt).toLocaleDateString()) + "</span>"
          : "";
        tracking += '<div class="ostk-track">' +
          (t.url ? '<a href="' + esc(t.url) + '" target="_blank" rel="noopener">' + label + "</a>" : label) +
          eta + "</div>";
      });
    });

    var date = o.createdAt ? new Date(o.createdAt).toLocaleDateString() : "";
    return '<div class="ostk-order">' +
      '<div class="ostk-order-head">' +
        '<span class="ostk-order-name">' + esc(o.name) + "</span>" +
        '<span class="ostk-order-date">' + esc(date) + "</span>" +
      "</div>" +
      '<div class="ostk-badges">' +
        '<span class="ostk-badge ' + badgeClass(o.fulfillmentStatus) + '">' + esc(o.fulfillmentStatus) + "</span>" +
        '<span class="ostk-badge ' + badgeClass(o.financialStatus) + '">' + esc(o.financialStatus) + "</span>" +
      "</div>" +
      (items ? '<ul class="ostk-items">' + items + "</ul>" : "") +
      tracking +
      "</div>";
  }

  function load() {
    var token = tokenFromUrl();
    if (!loggedIn && !token) {
      showMsg("Please sign in to view your orders, or open the tracking link from your order confirmation email.", "info");
      return;
    }
    root.setAttribute("aria-busy", "true");
    var url = path + (token ? "?token=" + encodeURIComponent(token) : "");
    fetch(url, { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        root.setAttribute("aria-busy", "false");
        if (!res.ok) {
          var err = res.body && res.body.error;
          if (err === "login_required") {
            showMsg("Please sign in to view your orders.", "info");
          } else if (err === "invalid_or_expired_token") {
            showMsg("That tracking link has expired. Request a new one or sign in to your account.", "error");
          } else {
            showMsg("Sorry, we couldn't load your orders right now. Please try again later.", "error");
          }
          return;
        }
        var orders = (res.body && res.body.orders) || [];
        if (!orders.length) {
          showMsg("No orders found.", "info");
          return;
        }
        if (msgEl) msgEl.hidden = true;
        listEl.innerHTML = orders.map(renderOrder).join("");
      })
      .catch(function () {
        root.setAttribute("aria-busy", "false");
        showMsg("Sorry, we couldn't load your orders right now. Please try again later.", "error");
      });
  }

  load();
})();
